import { render, staticRenderFns } from "./CreateFeedContainerActions.vue?vue&type=template&id=0895727c&"
import script from "./CreateFeedContainerActions.vue?vue&type=script&lang=ts&"
export * from "./CreateFeedContainerActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports